import React, { useContext, useState } from 'react';
import './Header.css';
import logo from '../assets/logo.png';
import { CartContext } from '../context/CartContext';
import { FaShoppingCart, FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // ✅ Import Link

function Header() {
  const { cartItems, toggleCart } = useContext(CartContext);
  const itemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <div className="header-top">
          {/* ✅ Logo links to home */}
          <Link to="/">
            <img src={logo} alt="Peels Native Logo" className="logo-img" />
          </Link>

          <div className="header-right">
            <div className="cart-wrapper" onClick={toggleCart}>
              <FaShoppingCart className="cart-icon" />
              {itemCount > 0 && <span className="cart-count">{itemCount}</span>}
            </div>

            <div className="mobile-menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>
        </div>

        <div className={`header-bottom ${menuOpen ? 'open' : ''}`}>
          <ul className="nav-menu">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/plants">Plants</Link></li>
            <li><Link to="/quote">Quote</Link></li>

            <li className="dropdown">
              <span onClick={() => toggleDropdown('sales')}>Sales</span>
              <ul className={`dropdown-menu ${openDropdown === 'sales' ? 'show' : ''}`}>
                <li><Link to="/sales">Information</Link></li>
              </ul>
            </li>

            <li><Link to="/about">About Us</Link></li>

            <li className="dropdown">
              <span onClick={() => toggleDropdown('contact')}>Contact</span>
              <ul className={`dropdown-menu ${openDropdown === 'contact' ? 'show' : ''}`}>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/feedback">Feedback</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
